(function () {
  function initializeDirectory(root) {
    if (!root || root.dataset.directoryReady === 'true') return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-directory-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-directory-panel]'));
    if (!tabs.length || !panels.length) return;

    function activate(route, moveFocus) {
      tabs.forEach(function (tab) {
        var selected = tab.dataset.directoryTab === route;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        if (selected && moveFocus) tab.focus({ preventScroll: true });
        if (selected && window.matchMedia('(max-width: 680px)').matches) {
          tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
      });

      panels.forEach(function (panel) {
        panel.hidden = panel.dataset.directoryPanel !== route;
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(tab.dataset.directoryTab, false);
      });

      tab.addEventListener('keydown', function (event) {
        var nextIndex = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === index && !['Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        activate(tabs[nextIndex].dataset.directoryTab, true);
      });
    });

    root.dataset.directoryReady = 'true';
  }

  function initializeAll(scope) {
    if (scope && scope.matches && scope.matches('[data-shop-directory]')) initializeDirectory(scope);
    var roots = (scope || document).querySelectorAll('[data-shop-directory]');
    Array.prototype.forEach.call(roots, initializeDirectory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
